import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Root from './pages/root';
import { Provider } from 'react-redux';
import store from './store';
// eslint-disable-next-line
import { iframeResizerContentWindow } from 'iframe-resizer';

const render = () => {
  ReactDOM.render(
    <Provider store={store}>
      <Root />
    </Provider>,
    document.getElementById('root')
  );
};

render();

if (module.hot) {
  module.hot.accept('./pages/root', function() {
    render();
  });
}



// WEBPACK FOOTER //
// ./src/index.js